import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { MyNotification } from '@models/my-notification';
import { NotificationFacade } from "@redux/facades/notification.facade";
import { Images } from '@constants/images';

@Component({
  standalone: false,
  selector: 'app-notification-general',
  templateUrl: './notification-general.component.html',
  styleUrls: ['./notification-general.component.scss']
})
export class NotificationGeneralComponent implements OnDestroy, OnInit {
  public images = Images;
  public notifications: MyNotification[] = [];
  public notification: MyNotification = { message: '', title: '', error: false, success: false, show: false, animation: '', className: '', image: '', timer: false };
  // @ts-ignore
  public unsubscribeNotification: Subscription;
  public showNotifications: boolean = false;
  public animation: string = 'show';

  constructor(
    public notificationFacade: NotificationFacade,
  ) {
    const self = this;
    self.unsubscribeNotification = self.notificationFacade.notificationState$.subscribe(
      (ok: any) => {
        if (ok.show) {
          self.notifications.push({
            // "message": self.notifications.length.toString() + '. ' + ok.message,
            "message": ok.message,
            "title": ok.title,
            "error": ok.error,
            "success": ok.success,
            "show": ok.show,
            "timer": ok.timer,
            "image": ok.error ? '' : '', // Images.IconError : ( ok.success ? Images.IconSuccess : Images.IconAlert );
            "className": ok.error ? 'error' : ( ok.success ? 'success' : 'alert' ),
            "animation": ok.show ? 'show' : ''
          });
          setTimeout(() => {
            const div = document.getElementById('div-notifications-container');
            if (div !== null && self.notifications.length > 2) {
              div.scroll({ top: self.notifications.length * -73, behavior:'smooth'});
              // div.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
          }, 1000)
        }
      }
    );
  }

  ngOnInit(): any {
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    const self = this;
    self.unsubscribeNotification.unsubscribe();
  }

  chageShowNotifications = (value: boolean) => {
    if (value) {
      this.showNotifications = value;
      this.animation = value ? 'show' : 'close';
      if (value && this.notifications.length === 0) {
        setTimeout( () => {
          this.chageShowNotifications(false);
        }, 2000);
      }
    } else {
      this.animation = value ? 'show' : 'close';
      setTimeout( () => {
        this.showNotifications = value;
      }, 450);
    }
  }

  closeNotification = (i: number) => {
    this.notifications[i].animation = 'close';
    setTimeout( () => {
      // this.notifications = this.notifications.splice(i, 1);
      this.notifications = this.notifications.filter(a => a.message !== this.notifications[i].message);
      // this.notificationFacade.closeNotification();
    }, 500);
    /* setTimeout( () => {
      this.animation = 'close';
    }, 5500);
    setTimeout( () => {
      this.notificationFacade.closeNotification();
    }, 6000); */
  }
}
